module.exports = __webpack_public_path__ + "img/15.219686f7.png";